(function () {
    'use strict';

    angular
        .module('app')
        .factory('SelectionCommand_WorkflowService', SelectionCommand_WorkflowService);

    SelectionCommand_WorkflowService.$inject = ['$http', '$q'];

    function SelectionCommand_WorkflowService($http, $q) {
        var service = {
            Assign: Assign,
            Unassign: Unassign,
            Approve: Approve,
            Reject: Reject,
            ExpediteApprove: ExpediteApprove,
            ExpediteReject: ExpediteReject,
            RejectTo: RejectTo,
            Reroute: Reroute,
            SetDocumentWorkflow: SetDocumentWorkflow,
            CreateVersion: CreateVersion,
            FinalApprove: FinalApprove,
            RestartWorkflow: RestartWorkflow,
            GetUserListForAssign: GetUserListForAssign,
            GetUserListForAssignWithLandingStep: GetUserListForAssignWithLandingStep,
            GetApproveOptionsList: GetApproveOptionsList,
            GetRerouteOptionsList: GetRerouteOptionsList,
            GetStepListForWorkflowCommand: GetStepListForWorkflowCommand,
            GetWorkflowListForWorkflowCommand: GetWorkflowListForWorkflowCommand,
            GetCheckInOptionsList: GetCheckInOptionsList,
            GetAllowUndoCheckOut: GetAllowUndoCheckOut
        };
        return service;

        // **************************************
        // BEGIN COMMANDS
        // **************************************

        // Call the Assign command with a Selection List.
        function Assign(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/Assign',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the Unassign command with a Selection List.
        function Unassign(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/Unassign',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the Assign command with a Selection List.
        function Approve(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/Approve',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the Unassign command with a Selection List.
        function Reject(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/Reject',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the Assign command with a Selection List.
        function ExpediteApprove(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/ExpediteApprove',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the Assign command with a Selection List.
        function ExpediteReject(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/ExpediteReject',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the Assign command with a Selection List.
        function RejectTo(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/RejectTo',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the Assign command with a Selection List.
        function Reroute(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/Reroute',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the Set Document Workflow command with a Selection List.
        function SetDocumentWorkflow(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/SetDocumentWorkflow',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the Create Version command with a Selection List.
        function CreateVersion(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/CreateVersion',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }


        // Call the Create Version command with a Selection List.
        function FinalApprove(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/FinalApprove',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }


        // Call the Create Version command with a Selection List.
        function RestartWorkflow(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/RestartWorkflow',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // **************************************
        // END COMMANDS
        // **************************************

        // Get the assign-to user list for this command.
        function GetUserListForAssign(slx, commandNumber) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/UserListForAssign/'.concat(commandNumber),
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Get the assign-to user list for this command where the landing step is user selected.
        function GetUserListForAssignWithLandingStep(slx, commandNumber) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/UserListForAssignWithLandingStep/'.concat(commandNumber),
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the Unassign command with a Selection List.
        function GetApproveOptionsList(slx, commandNumber) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/ApproveOptionsList/'.concat(commandNumber),
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the Unassign command with a Selection List.
        function GetRerouteOptionsList(slx, commandNumber) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/RerouteOptionsList/'.concat(commandNumber),
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the list of available steps for a list and a command.
        function GetStepListForWorkflowCommand(slx, commandNumber) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/StepListForWorkflowCommand/'.concat(commandNumber),
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the list of available steps for a list and a command.
        function GetWorkflowListForWorkflowCommand(slx, commandNumber) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/WorkflowListForWorkflowCommand/'.concat(commandNumber),
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the Unassign command with a Selection List.
        function GetCheckInOptionsList(checkInOptionsList) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/CheckInOptionsList',
                method: 'PUT',
                data: JSON.stringify(checkInOptionsList),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the Unassign command with a Selection List.
        function GetAllowUndoCheckOut() {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/AllowUndoCheckOut',
                method: 'PUT',
                data: JSON.stringify(),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

    }
})();